var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: {
        "max-width": "900px",
        "max-height": "400px",
        bus: _vm.busModal,
        persistent: ""
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c("v-spacer"),
              _vm.step === 1
                ? _c(
                    "BaseButton",
                    { attrs: { underlined: "" }, on: { click: close } },
                    [_vm._v(" Cancelar ")]
                  )
                : _vm._e(),
              _vm.step === 2 && _vm.bank.edit
                ? _c(
                    "BaseButton",
                    { attrs: { underlined: "" }, on: { click: close } },
                    [_vm._v(" Cancelar ")]
                  )
                : _vm._e(),
              _vm.step === 2 && !_vm.bank.edit
                ? _c(
                    "BaseButton",
                    {
                      attrs: { underlined: "" },
                      on: {
                        click: function($event) {
                          _vm.step = Number(_vm.step) - 1
                        }
                      }
                    },
                    [_vm._v(" Voltar ")]
                  )
                : _vm._e(),
              _vm.step === 1 && !_vm.banco
                ? _c("BaseButton", { attrs: { secondary: "" } }, [
                    _vm._v(" Confirmar ")
                  ])
                : _vm._e(),
              _vm.step === 1 && _vm.banco
                ? _c(
                    "BaseButton",
                    { attrs: { primary: "" }, on: { click: _vm.nextStep } },
                    [_vm._v(" Confirmar ")]
                  )
                : _vm._e(),
              _vm.step === 2 && _vm.bank.edit
                ? _c(
                    "BaseButton",
                    {
                      attrs: { primary: "", loading: _vm.loading },
                      on: {
                        click: function($event) {
                          return _vm.newAccount(close)
                        }
                      }
                    },
                    [_vm._v(" Editar ")]
                  )
                : _vm._e(),
              _vm.step === 2 && !_vm.bank.edit
                ? _c(
                    "BaseButton",
                    {
                      attrs: { primary: "", loading: _vm.loading },
                      on: {
                        click: function($event) {
                          return _vm.newAccount(close)
                        }
                      }
                    },
                    [_vm._v(" Cadastrar ")]
                  )
                : _vm._e(),
              _c("v-spacer")
            ]
          }
        }
      ])
    },
    [
      _c("div", [
        _c(
          "div",
          { staticClass: "v-application" },
          [
            _c("SectionTitle", {
              attrs: {
                title:
                  (_vm.bank.edit ? "Editar" : "Cadastrar") +
                  " conta de investimento"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          [
            _c(
              "v-stepper",
              {
                staticClass: "elevation-0",
                style: {
                  "margin-top": "20px"
                },
                model: {
                  value: _vm.step,
                  callback: function($$v) {
                    _vm.step = $$v
                  },
                  expression: "step"
                }
              },
              [
                !_vm.bank.edit
                  ? _c(
                      "v-stepper-header",
                      { staticClass: "elevation-0" },
                      [
                        _c(
                          "v-stepper-step",
                          {
                            attrs: {
                              step: "1",
                              complete: _vm.step > 1,
                              editable: _vm.step > 1
                            }
                          },
                          [_vm._v(" Escolha sua instituição ")]
                        ),
                        _c("v-divider"),
                        _c("v-stepper-step", { attrs: { step: "2" } }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                (_vm.bank.edit ? "Edite" : "Cadastre") +
                                  " sua conta"
                              ) +
                              " "
                          )
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "v-stepper-items",
                  { staticClass: "elevation-0" },
                  [
                    _c(
                      "v-stepper-content",
                      { attrs: { step: "1" } },
                      [
                        _c(
                          "v-form",
                          { ref: "formPrimary" },
                          [
                            _vm.banco === 273
                              ? _c(
                                  "div",
                                  { staticStyle: { "margin-bottom": "20px" } },
                                  [
                                    _c(
                                      "small",
                                      {
                                        staticClass: "text-secondary",
                                        staticStyle: { "text-align": "justify" }
                                      },
                                      [
                                        _vm._v(
                                          " As informações do CEI são consolidadas em D-2, movimentações feitas após esse período podem não ser refletidas aqui em sua carteira. "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "small",
                                      {
                                        staticClass: "text-secondary",
                                        staticStyle: { "text-align": "justify" }
                                      },
                                      [
                                        _vm._v(
                                          " Os dados possuem histórico de até 1 ano e meio e Títulos Públicos e Renda Fixa não são consolidados automaticamente, insira manualmente em Cadastro -> Ativo. "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _c("v-select", {
                              class: _vm.$style.fields,
                              attrs: {
                                items: _vm.bancos,
                                label: "Selecione sua instituição*",
                                "item-text": "nome",
                                "item-value": "id_banco",
                                required: "",
                                rules: [_vm.rules.required]
                              },
                              on: { change: _vm.collectFieldsRequireds },
                              model: {
                                value: _vm.banco,
                                callback: function($$v) {
                                  _vm.banco = $$v
                                },
                                expression: "banco"
                              }
                            }),
                            _c(
                              "div",
                              {
                                staticStyle: { cursor: "pointer" },
                                on: { click: _vm.openInsituicaoNaoEncontrada }
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticStyle: {
                                      "margin-top": "20px",
                                      "text-decoration": "underline",
                                      color: "primary"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " Não encontrou a instituição desejada? "
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-stepper-content",
                      { attrs: { step: "2" } },
                      [
                        _c(
                          "v-form",
                          {
                            ref: "form",
                            model: {
                              value: _vm.formValid,
                              callback: function($$v) {
                                _vm.formValid = $$v
                              },
                              expression: "formValid"
                            }
                          },
                          [
                            _vm.campos.includes("cpf") &&
                            _vm.banco !== _vm.CODIGO_CEI
                              ? _c("v-text-field", {
                                  directives: [
                                    {
                                      name: "mask",
                                      rawName: "v-mask",
                                      value: _vm.mask.cpf,
                                      expression: "mask.cpf"
                                    }
                                  ],
                                  class: _vm.$style.fields,
                                  attrs: {
                                    label: "CPF*",
                                    rules: [_vm.rules.required]
                                  },
                                  model: {
                                    value: _vm.cpf,
                                    callback: function($$v) {
                                      _vm.cpf = $$v
                                    },
                                    expression: "cpf"
                                  }
                                })
                              : _vm._e(),
                            _vm.campos.includes("cpf") &&
                            _vm.banco === _vm.CODIGO_CEI
                              ? _c("v-text-field", {
                                  directives: [
                                    {
                                      name: "mask",
                                      rawName: "v-mask",
                                      value: [_vm.mask.cpf, _vm.mask.cnpj],
                                      expression: "[mask.cpf, mask.cnpj]"
                                    }
                                  ],
                                  class: _vm.$style.fields,
                                  attrs: {
                                    label: "CPF/CNPJ*",
                                    rules: [
                                      _vm.rules.required,
                                      _vm.rules.cpf_cnpj
                                    ]
                                  },
                                  model: {
                                    value: _vm.cpf,
                                    callback: function($$v) {
                                      _vm.cpf = $$v
                                    },
                                    expression: "cpf"
                                  }
                                })
                              : _vm._e(),
                            _vm.campos.includes("agencia")
                              ? _c("v-text-field", {
                                  directives: [
                                    {
                                      name: "mask",
                                      rawName: "v-mask",
                                      value: _vm.mask.number,
                                      expression: "mask.number"
                                    }
                                  ],
                                  class: _vm.$style.fields,
                                  attrs: {
                                    label:
                                      _vm.cod_banco === 341 ||
                                      _vm.cod_banco === 237
                                        ? "Agência*"
                                        : "Agência com digito*",
                                    rules: [_vm.rules.required]
                                  },
                                  model: {
                                    value: _vm.agencia,
                                    callback: function($$v) {
                                      _vm.agencia = $$v
                                    },
                                    expression: "agencia"
                                  }
                                })
                              : _vm._e(),
                            _vm.campos.includes("conta")
                              ? _c("v-text-field", {
                                  directives: [
                                    {
                                      name: "mask",
                                      rawName: "v-mask",
                                      value: _vm.mask.number,
                                      expression: "mask.number"
                                    }
                                  ],
                                  class: _vm.$style.fields,
                                  attrs: {
                                    label: _vm.is_corretora
                                      ? "Conta corretora*"
                                      : "Conta corrente com dígito*",
                                    rules: [_vm.rules.required]
                                  },
                                  model: {
                                    value: _vm.conta,
                                    callback: function($$v) {
                                      _vm.conta = $$v
                                    },
                                    expression: "conta"
                                  }
                                })
                              : _vm._e(),
                            _vm.campos.includes("email")
                              ? _c("v-text-field", {
                                  class: _vm.$style.fields,
                                  attrs: {
                                    label: "E-mail*",
                                    rules: [_vm.rules.email]
                                  },
                                  model: {
                                    value: _vm.email,
                                    callback: function($$v) {
                                      _vm.email = $$v
                                    },
                                    expression: "email"
                                  }
                                })
                              : _vm._e(),
                            _vm.campos.includes("senha")
                              ? _c(
                                  "div",
                                  [
                                    _c("p", { class: _vm.$style.obrigatorio }, [
                                      _vm._v(
                                        " A senha do internet banking é a senha de acesso a sua conta e que nos possibilita apenas a visualização dos seus dados, não podemos realizar nenhuma ação em sua conta com ela. "
                                      )
                                    ]),
                                    _c("v-text-field", {
                                      class: _vm.$style.fields,
                                      attrs: {
                                        "append-icon": _vm.show1
                                          ? "visibility"
                                          : "visibility_off",
                                        type: _vm.show1 ? "text" : "password",
                                        label: _vm.is_corretora
                                          ? "Senha corretora*"
                                          : "Senha internet banking*",
                                        rules: [_vm.rules.required]
                                      },
                                      on: {
                                        "click:append": function($event) {
                                          _vm.show1 = !_vm.show1
                                        }
                                      },
                                      model: {
                                        value: _vm.senha,
                                        callback: function($$v) {
                                          _vm.senha = $$v
                                        },
                                        expression: "senha"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.cod_banco === _vm.CODIGO_SANTANDER
                              ? _c("p", { class: _vm.$style.obrigatorio }, [
                                  _vm._v(
                                    " Não se preocupe caso você receba uma mensagem do Santander pedindo para autorizar/habilitar a AAWZ no caixa eletrônico. Nosso acesso é apenas de visualização."
                                  )
                                ])
                              : _vm._e(),
                            _vm.edit_cotizar_conta ||
                            _vm.cod_banco === _vm.CODIGO_XP
                              ? _c(
                                  "div",
                                  [
                                    _c("v-switch", {
                                      attrs: {
                                        label:
                                          "Não coletar informações da rentabilidade.",
                                        dense: "",
                                        "hide-details": ""
                                      },
                                      model: {
                                        value: _vm.cotizar_conta,
                                        callback: function($$v) {
                                          _vm.cotizar_conta = $$v
                                        },
                                        expression: "cotizar_conta"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              [
                                _c("v-switch", {
                                  attrs: {
                                    label:
                                      "Não coletar informações do saldo bruto.",
                                    dense: "",
                                    "hide-details": ""
                                  },
                                  model: {
                                    value: _vm.cotizar_pl,
                                    callback: function($$v) {
                                      _vm.cotizar_pl = $$v
                                    },
                                    expression: "cotizar_pl"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              [
                                _c("v-switch", {
                                  attrs: {
                                    label:
                                      "Atualizar dados automaticamente todos os dias.",
                                    dense: "",
                                    "hide-details": ""
                                  },
                                  model: {
                                    value: _vm.att_diaria,
                                    callback: function($$v) {
                                      _vm.att_diaria = $$v
                                    },
                                    expression: "att_diaria"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              [
                                _c("v-checkbox", {
                                  attrs: {
                                    required: "",
                                    rules: [_vm.rules.required],
                                    label:
                                      "Autorizo o acesso a meus dados financeiros pessoais na instituição " +
                                      _vm.nome_banco +
                                      " somente em modo leitura"
                                  },
                                  model: {
                                    value: _vm.check,
                                    callback: function($$v) {
                                      _vm.check = $$v
                                    },
                                    expression: "check"
                                  }
                                })
                              ],
                              1
                            ),
                            _c("p", { class: _vm.$style.obrigatorio }, [
                              _vm._v("* Obrigatório")
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }